'use client';

import { DateTime } from 'luxon';

import { createFileRoute, useSearch } from '@tanstack/react-router';

import TimesheetWeekGrid from '@/modules/Timesheet/TimesheetWeekGrid';

export const Route = createFileRoute('/app/timesheet/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      week: search.week as string | undefined,
    };
  },
});

function RouteComponent() {
  const searchParams = useSearch({ from: '/app/timesheet/' });

  const initialWeek = searchParams.week
    ? DateTime.fromISO(searchParams.week).startOf('week')
    : DateTime.now().startOf('week');

  return <TimesheetWeekGrid initialWeek={initialWeek} />;
}
